import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import appcolors from "../../../constants/Colors";
import { t } from "i18next";
import { CURRENCY } from "../../../constants/Variables";

let monthsss = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const AdminBarChart = ({ chartData }) => {
  useEffect(() => {
    // Create root element
    const root = am5.Root.new(`adminBarchartDiv`);

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
        paddingLeft: 0,
        paddingRight: 1,
      })
    );

    // Add cursor
    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);

    // Create X-Axis
    const xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 30,
      minorGridEnabled: true,
    });

    xRenderer.labels.template.setAll({
      rotation: -90,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
    });

    xRenderer.grid.template.setAll({
      location: 1,
    });

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "month",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    // Create Y-Axis
    const yRenderer = am5xy.AxisRendererY.new(root, {
      strokeOpacity: 0.1,
    });

    yRenderer.labels.template.setAll({
      visible: true, // Show labels on y-axis
      fontSize: 12,
      fontWeight: "500",
      fill: am5.color("#555"),
      paddingRight: 10,
    });

    yRenderer.grid.template.setAll({
      visible: true, // Show grid lines on y-axis
      strokeOpacity: 0.1,
    });

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0.3,
        renderer: yRenderer,
      })
    );

    // Create series
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: `${t("series")} 1`,
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "earning",
        sequencedInterpolation: true,
        categoryXField: "month",
        tooltip: am5.Tooltip.new(root, {
          labelText: `Total Orders: {totalOrders}\nEarning: {valueY} ${CURRENCY}`,
          background: am5.RoundedRectangle.new(root, {
            fill: am5.color("#000000"),
          }),
        }),
      })
    );

    // Adapter to set different colors based on active month
    series.columns.template.adapters.add("fill", (fill, target) => {
      const dataItem = target.dataItem;
      let currentMonth = monthsss[new Date().getMonth()];
      if (dataItem?.dataContext.month === currentMonth) {
        return am5.color(appcolors.primary);
      } else {
        return am5.color("#F3EBFF");
      }
    });

    series.columns.template.setAll({
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
      strokeOpacity: 0,
    });

    xAxis.data.setAll(chartData);
    series.data.setAll(chartData);

    // Make stuff animate on load
    series.appear(1000);
    chart.appear(1000, 100);

    // Cleanup function
    return () => {
      chart.dispose();
      root.dispose();
    };
  }, [chartData]);

  return (
    <div id="adminBarchartDiv" style={{ width: "100%", height: "400px" }}></div>
  );
};

export default AdminBarChart;
